import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjAcceptOrders"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.74512 2.01294C4.05476 2.01294 3.49512 2.57258 3.49512 3.26294V16.7627C3.49512 17.4531 4.05476 18.0127 4.74512 18.0127H15.2456C15.936 18.0127 16.4956 17.453 16.4956 16.7627V6.12407L12.3928 2.01294H4.74512ZM13.9831 9.45013C14.1579 9.23641 14.1264 8.9214 13.9127 8.74653L13.3968 8.32437C13.183 8.14951 12.868 8.18101 12.6932 8.39473L9.50416 12.2924C9.37218 12.4537 9.13398 12.4764 8.97386 12.343L7.15445 10.8268C6.94232 10.6501 6.62703 10.6787 6.45025 10.8909L6.02346 11.403C5.84668 11.6151 5.87534 11.9304 6.08748 12.1072L8.90815 14.4578C9.22839 14.7246 9.70479 14.6792 9.96876 14.3565L13.9831 9.45013Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M12.3809 2.01294L16.4952 6.12732H12.3809V2.01294Z",
  fill: "white"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var SJ_Accept_orders = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_Accept_orders as default };
